export default {
  'searchParts.label.automaker': 'Montadora',
  'searchParts.label.model': 'Modelo',
  'searchParts.label.searchType': 'Tipo de Pesquisa',

  'searchParts.column.description': 'Descrição',
  'searchParts.column.barcode': 'Código de Barras',
  'searchParts.column.manufacturerCode': 'Código de Fabricante',
  'searchParts.column.internalcode': 'Código Interno',
  'searchParts.column.companyCode': 'Código da Empresa',

  'searchParts.button.filter': 'Filtrar',
  'searchParts.button.clean': 'Limpar',
  'searchParts.button.select': 'Selecionar',

  'searchParts.option.global': 'Global',
  'searchParts.option.free': 'Por campo -  Livre',
  'searchParts.option.specify': 'Por campo – Especifica',
};
